<div #contentToScroll id="content2scroll">
<h2>Bashan Foundation Members</h2>
<table mat-table [dataSource]="$dataSource" matSort class="members-table">
  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>

  <!-- Research Area Column -->
  <ng-container matColumnDef="researchArea">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Research Area</th>
    <td mat-cell *matCellDef="let row">{{ row.researchArea }}</td>
  </ng-container>

  <!-- Country Column -->
  <ng-container matColumnDef="country">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
    <td mat-cell *matCellDef="let row">
      <span class="fi fi-{{ row.country }}"></span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row.slug)"></tr>
</table>
</div>
